<script setup>
import ManageCardsSectionCard from '@/Components/Payments/ManageCardsSectionCard'
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
    organisation: {
        type: Array,
        default: () => ([]),
    },
})
</script>

<template>
	<ManageCardsSectionCard
		v-if="auth.can('manage_payment_methods', 'organisations', organisation.id)"
		:organisation="organisation"
	/>
	<SectionCard v-else :full-width="true">
		<template #header>
			<div class="flex justify-between items-center">
				<span class="text-lg font-medium text-gray-900 mb-0">Saved Cards</span>
			</div>
		</template>
		<div class="p-4">
			<p class="text-gray-500">
				You do not have permission to manage payment methods for this organisation.
			</p>
		</div>
	</SectionCard>
</template>